import { render, staticRenderFns } from "./ChatReportDetails.vue?vue&type=template&id=564e0856&scoped=true&"
import script from "./ChatReportDetails.vue?vue&type=script&lang=ts&"
export * from "./ChatReportDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ChatReportDetails.vue?vue&type=style&index=0&id=564e0856&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e0856",
  null
  
)

export default component.exports